export const APP_API = "http://167.235.158.238/feedbacks";